import React from 'react';
import { createRoot } from "react-dom/client";
import "../src/Styles/index.scss"

import App from './App';


createRoot(document.getElementById("root")).render(
    
    <App />
   
  );


